export default __webpack_public_path__ + "static/media/theoda.ae50a0cd.jpg";